<template>
  <el-dialog :title="$t('activitiesSignUpManage.detail.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-descriptions :column="2" border>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.signUpId')">{{ detail.signUpId }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.activitiesTitle')">{{ detail.activitiesTitle }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.userName')">{{ detail.userName }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.userTel')">{{ detail.userTel }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.peopleCount')">{{ detail.peopleCount }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.payAmount')">{{ formatPayAmount(detail) }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.stateName')">{{ detail.stateName }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.table.createTime')">{{ detail.createTime }}</el-descriptions-item>
      <el-descriptions-item :label="$t('activitiesSignUpManage.detail.remark')">{{ detail.remark || '-' }}</el-descriptions-item>
    </el-descriptions>

    <div v-if="personList.length > 0" style="margin-top: 20px;">
      <div class="section-title">{{ $t('activitiesSignUpManage.detail.personList') }}</div>
      <el-table :data="personList" border style="width: 100%">
        <el-table-column type="index" :label="$t('activitiesSignUpManage.detail.index')" width="60" align="center" />
        <el-table-column prop="userName" :label="$t('activitiesSignUpManage.detail.personName')" align="center" />
        <el-table-column prop="userTel" :label="$t('activitiesSignUpManage.detail.personTel')" align="center" />
        <el-table-column prop="idCard" :label="$t('activitiesSignUpManage.detail.idCard')" align="center" />
      </el-table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailActivitiesSignUpView',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      personList: []
    }
  },
  methods: {
    formatPayAmount(row) {
      if (!row || row.isCharge !== 'Y') {
        return '-'
      }
      if (row.payAmount === null || row.payAmount === undefined || row.payAmount === '') {
        return '-'
      }
      return `${row.payAmount}元`
    },
    open(row) {
      this.dialogVisible = true
      this.detail = { ...row }
      this.personList = this.parsePersonInfos(row.personInfos)
    },
    parsePersonInfos(personInfos) {
      if (!personInfos) {
        return []
      }
      try {
        const list = typeof personInfos === 'string' ? JSON.parse(personInfos) : personInfos
        return Array.isArray(list) ? list : []
      } catch (error) {
        console.error('解析参加人员信息失败:', error)
        return []
      }
    },
    handleClose() {
      this.detail = {}
      this.personList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
